import React, {useState} from 'react';
import './App.css';
import 'primereact/resources/themes/lara-light-amber/theme.css';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';
import Login from "./components/Login";
import MainScreen from "./components/MainScreen";
import {ToastContextProvider} from "./lib/context/ToastContext";
import {ClickStat} from "./lib/types/types";
import {DialogContextProvider} from "./lib/context/DialogContext";
import {ConfirmDialogContextProvider} from "./lib/context/ConfirmDialogContext";
import {IntlProvider, useIntl} from 'react-intl';
import messages_en from "./lib/textProperties/en.json"
import {configureApp} from "./lib/configureApp";


const App = () => {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    const messages = {'en': messages_en}

    const handleLogin = () => {
        setIsUserLoggedIn(true);
    }

    return <>
        <IntlProvider locale={"en-EN"} messages={messages.en} defaultLocale={"en-EN"}>
            <ToastContextProvider>
                <DialogContextProvider>
                    <ConfirmDialogContextProvider>
                        {isUserLoggedIn ?
                        <div className={"container"}>
                            <MainScreen/>
                        </div>
                            :
                            <Login onSuccessfulLogin={handleLogin}/>
                        }

                    </ConfirmDialogContextProvider>
                </DialogContextProvider>
            </ToastContextProvider>
        </IntlProvider>
    </>
}

export default App;
